const CONST = {
    KEY : {
        FIELD : {
            WIDTH      : '$_WIDTH',
        },
    },
    VAL : {
        DEFAULT_HEIGHT:450,
        DIRTY : {
            FLAG : {
                CREATE : 'C',
                UPDATE : 'U',
                REMOVE : 'R'
            }
        }
    },
    KEYCODE: {
        BS        : 8,
        BACKSPACE : 8,
        TAB       : 9,
        ENTER     : 13,
        ESC       : 27,
        SHIFT     : 16,
        CTRL      : 17,
        CONTROL   : 17,
        ALT       : 18,
        SPACE     : 32,
        PAGEUP    : 33,
        PAGEDOWN  : 34,
        END       : 35,
        HOME      : 36,
        UP        : 38,
        DOWN      : 40,
        LEFT      : 37,
        RIGHT     : 39,
        INSERT    : 45,
        DEL       : 46,
        DELETE    : 46,
        F1        : 112,
        F2        : 113,
        F3        : 114,
        F4        : 115,
        F5        : 116,
        F6        : 117,
        F7        : 118,
        F8        : 119,
        F9        : 120,
        F10       : 121,
        F11       : 122,
        F12       : 123,
    }
};

Object.freeze(CONST); // need deep?
export default CONST;